import PropTypes from 'prop-types';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Provider } from './AnalyticsContext';
import { fetchToken } from '../../actions/auth';
import Analytics from '../../utils/analytics';
import User from '../../models/User';

export class AnalyticsProvider extends React.Component {
    static propTypes = {
        accessToken: PropTypes.string,
        children: PropTypes.element,
        eventsApiOptions: PropTypes.shape({
            timeout: PropTypes.number
        }),
        user: PropTypes.instanceOf(User),
        fetchToken: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);
        this.accessTokenProvider = this.accessTokenProvider.bind(this);
        if (!window.analytics) {
            window.analytics = new Analytics(this.accessTokenProvider, props.eventsApiOptions, props.user);
        }
    }

    componentDidUpdate() {
        if (window.analytics && this.props.user) {
            window.analytics.setUser(this.props.user);
        }
    }

    accessTokenProvider() {
        return Promise.resolve(this.props.accessToken);
    }

    render() {
        return <Provider value={window.analytics}>{this.props.children}</Provider>;
    }
}

const mapStateToProps = (state) => ({
    accessToken: state.auth.accessToken,
    user: state.user
});

const mapDispatchToProps = (dispatch) => ({
    fetchToken: bindActionCreators(fetchToken, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(AnalyticsProvider);
